import { v4 as uuidv4 } from "uuid";
export class CalendarEventSaveModel {
    constructor() {
        this.id = uuidv4();
        this.title = "";
        this.stateId = "";
        this.dueDate = null;
        this.dueDateAsString = "";
        this.url = "";
        this.description = "";
        this.recurrenceRule = "";
    }
}
export default class CalendarEventSave extends CalendarEventSaveModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
